import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KSideBarModule } from 'ng-k-side-bar';
import { ClaimInsightsRoutingModule } from './claims-insights-routing.module';
import { ClaimsInsightsContainerComponent } from './claims-insights-container/claims-insights-container.component';
import { ClaimInsightsReportComponent } from './claim-insights-report/claim-insights-report.component';
import { PowerBIEmbedModule } from 'powerbi-client-angular';



@NgModule({
  declarations: [ 
    ClaimsInsightsContainerComponent, ClaimInsightsReportComponent
  ],
  imports: [
    CommonModule,
    KSideBarModule,
    ClaimInsightsRoutingModule,
    PowerBIEmbedModule
  ],
  exports: [
    KSideBarModule
  ]
})
export class ClaimsInsightsModule { }
